import { Component } from 'react';

import ContentOuterBound from './common/atoms/ContentOuterBound';
import ContentSpacer from './common/atoms/ContentSpacer';
import HeaderTextGroupMolecule from './common/molecules/HeaderTextGroup';

import * as InternalPropTypes from '../constants/internal-types';
import {
  HeaderTextGroupTypeEnum,
  TypeBackgroundColorTypes,
  TypeHeaderTextGroupTypes,
  TypeSEOWeightTypes,
} from '../constants/cms-constants';
import SEOWeights from '../constants/cms/control-options/seo-weights';

const styles = {
  '&.wide, &.large-wide': {
    paddingTop: '56px',
    paddingBottom: '56px',
  },
  '&.narrow, &.large-narrow': {
    paddingTop: '135px',
  },
};

type HeaderTextGroupProps = {
  type?: TypeHeaderTextGroupTypes;
  headerText?: InternalPropTypes.RichText;
  bodyText?: InternalPropTypes.RichText;
  link?: InternalPropTypes.Link;
  backgroundColor?: TypeBackgroundColorTypes;
  seoWeight?: TypeSEOWeightTypes;
};

class HeaderTextGroup extends Component<HeaderTextGroupProps> {
  static types = HeaderTextGroupMolecule.types;

  static defaultProps = {
    type: HeaderTextGroupTypeEnum.WIDE,
    headerText: null,
    bodyText: null,
    link: null,
    backgroundColor: null,
    seoWeight: SEOWeights.H2,
  };

  render() {
    const { type, headerText, bodyText, link, backgroundColor, seoWeight } =
      this.props;

    const addStyle = backgroundColor ? { background: backgroundColor } : {};
    return (
      <div
        className={`header-text-group-component ${type}`}
        css={[styles, addStyle]}
      >
        <ContentOuterBound>
          <ContentSpacer>
            <HeaderTextGroupMolecule
              headerText={headerText}
              bodyText={bodyText}
              link={link}
              type={type}
              seoWeight={seoWeight}
            />
          </ContentSpacer>
        </ContentOuterBound>
      </div>
    );
  }
}

export default HeaderTextGroup;
